import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  RotationCreateDto,
  RotationUpdateDto,
} from '../proxy/geographic/dtos/rotation';
import { ROTATION_CONFIG, ROTATION_FIELDS } from './rotation.config';
import {
  BaseHierarchicalCrudComponent,
  GenericForm,
  ICrudService,
  ZnHierarchicalViewComponent,
} from '@zendra/shared';
import { RotationService } from '../proxy/geographic/controllers';
import { RotationProjectionPlanningOrchestratorService } from 'orchestrator';
import {
  GetRotationProjectionListInputDto,
  RotationProjectionExcelDownloadDto,
  RotationProjectionDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/rotations/models';

@Component({
  selector: 'app-rotation',
  imports: [
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, RotationService, ConfirmationService],
  templateUrl: './rotation.html',
  styleUrl: './rotation.scss',
})
export class Rotation extends BaseHierarchicalCrudComponent<
  RotationProjectionDto,
  RotationCreateDto,
  RotationUpdateDto,
  RotationProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  geographicService = inject(RotationService);
  orchestratorService = inject(RotationProjectionPlanningOrchestratorService);
  service: ICrudService<
    RotationProjectionDto,
    RotationCreateDto,
    RotationUpdateDto,
    RotationProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('rotations', ids),
    getList: (query: GetRotationProjectionListInputDto) => this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.orchestratorService, 'rotationId'),
  };
  config = ROTATION_CONFIG;
  fields = ROTATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: RotationProjectionDto): RotationUpdateDto {
    if (!selected.concurrencyStamp) {
      throw new Error('Rotation concurrency stamp is missing.');
    }

    return {
      rotationUseId: data.rotationUseId,
      rotationPurposeId: data.rotationPurposeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Rotation';
  }
}
